import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import { ContactInformation, ShippingAddress, BillingAddress, CheckBoxes } from './../forms/indexForms';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import { saveCustomer } from '../helpers/saveCustomer';
import LoadingScreen from './LoadingScreen'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import throttle from 'lodash.throttle';

const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(1),
        float: 'right',
    },
    text: {
        padding: theme.spacing(2, 2, 0),
    },
    grdButton: {
        flex: 1,
    },
    paper: {
        paddingBottom: 50,
    },
    list: {
        marginBottom: theme.spacing(2),
    },
    subheader: {
        backgroundColor: theme.palette.background.paper,
    },
    appBottomBar: {
        top: 'auto',
        bottom: 0,
    },
    appTopBar: {
        top: 0,
        bottom: 'auto',
    },
    grow: {
        flexGrow: 1,
    },
    fabButton: {
        position: 'absolute',
        zIndex: 1,
        top: -30,
        left: 0,
        right: 0,
        margin: '0 auto',
    },
}));

const getDeviceConfig = (width) => {
    console.log(width);
    if (width <= 1290 ) {
      return true;
    } else {
      return false;
    }
}

const FirstScreen = () => {

    const [brkPnt, setBrkPnt] = useState(() => getDeviceConfig(window.innerWidth));
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [loading, setLoading] = useState(false);

    console.log(brkPnt);

    useEffect(() => {
        const calcInnerWidth = throttle(function() {
          setBrkPnt(getDeviceConfig(window.innerWidth))
        }, 200); 
        window.addEventListener('resize', calcInnerWidth);
        window.removeEventListener('resize', calcInnerWidth);
      }, []);

    const checkOutSession = async () => {

        setLoading(true);
        const stripe = window.Stripe('pk_test_iuByH5f4BUmh0fWINLBbtC3F00uQW114mD');
        try {
            const session = await saveCustomer();
            await stripe.redirectToCheckout({
                sessionId: session.data.id
            });
        } catch (error) {
            console.log(error);
            window.location.href = `${window.location.protocol}//${window.location.hostname}/error`;
        }

    }

    return (
        <div>
            {loading ? (
                <LoadingScreen />
            ) : (
                    <Grid container spacing={4}>
                        <img src={require('./../assets/Contele-Fleet-Tracking.png')} alt="" className="topLogoImage" />
                        <AppBar position="fixed" color="inherit" className={useStyles.appTopBar}>
                            <Toolbar>
                                <div className={useStyles.grow} />
                            </Toolbar>
                        </AppBar>
                       { brkPnt ? <Grid item xs={12} sm={6} style={{marginTop: '167px'}}>
                            <ContactInformation setButtonDisabled={setButtonDisabled} />
                        </Grid> : <Grid item xs={12} sm={6}>
                            <ContactInformation setButtonDisabled={setButtonDisabled} />
                        </Grid>}
                        { brkPnt ? <Grid item xs={12} sm={6} style={{marginTop: '167px'}}>
                            <ShippingAddress setButtonDisabled={setButtonDisabled} />
                        </Grid> : <Grid item xs={12} sm={6}>
                            <ShippingAddress setButtonDisabled={setButtonDisabled} />
                        </Grid>}
                        <Grid item xs={12} sm={6}>
                            <BillingAddress setButtonDisabled={setButtonDisabled} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CheckBoxes setButtonDisabled={setButtonDisabled} />
                        </Grid>
                        <div style={{ flex: 1, justifyContent: 'flex-end',display: 'flex'}} >
                            <Button variant="contained" color="primary" style={{ width: '274px', height: '48px', }} disabled={buttonDisabled} className={useStyles.button} onClick={checkOutSession}>
                                Order Now
                    </Button>
                        </div>

                    </Grid>
                )}
        </div>

    );

};

export default FirstScreen;